var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useMemo } from 'react';
import { MakhazinApi } from '../Api';
import Loading from '../Components/Loading';
import ActionBar from '../Components/ActionBar';
import { Typography, Grid, CircularProgress, Box } from '@mui/material';
import { useNavigate } from 'react-router';
import { useSnackbar } from 'notistack';
import { PasswordField } from '../Components/Field';
import { useStyles } from './User.styles';
import useApiAbort from '../Api/Core/useApiAbort';
import { useParams, Navigate } from 'react-router-dom';
export const ResetPassword = () => {
    const navigate = useNavigate();
    const { token } = useParams();
    const abortController = useApiAbort();
    const [valid, setValid] = useState();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    useEffect(() => {
        const validateToken = (token) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const result = yield new MakhazinApi(abortController.current).validateResetPasswordToken(token);
                if (result === false) {
                    enqueueSnackbar('Länken är inte längre aktiv', { variant: 'info' });
                }
                setValid(result);
            }
            catch (_) {
                if (!abortController.current.signal.aborted) {
                    throw _;
                }
            }
        });
        validateToken(token);
    }, [token, enqueueSnackbar, abortController]);
    const handleResetPassword = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!validForm) {
            return;
        }
        setLoading(true);
        try {
            yield new MakhazinApi(abortController.current).updatePassword(password, confirmPassword, token);
            enqueueSnackbar('Ditt lösenord är nu uppdaterat', { variant: 'success' });
            navigate('/login');
        }
        catch (exception) {
            if (!abortController.current.signal.aborted) {
                enqueueSnackbar('Något gick fel. Ditt lösenord kunde inte uppdateras', { variant: 'error' });
            }
        }
        setLoading(false);
    });
    const handleFormSubmit = (event) => {
        event.preventDefault();
        handleResetPassword();
        return false;
    };
    const validForm = useMemo(() => {
        return password !== undefined && password.length > 6 && password === confirmPassword;
    }, [password, confirmPassword]);
    return (React.createElement(React.Fragment, null,
        (valid === undefined && React.createElement(Loading, null)) || (valid === false && React.createElement(Navigate, { to: "/" })),
        valid && (React.createElement(Box, { component: "section" },
            React.createElement("form", { onSubmit: handleFormSubmit },
                React.createElement(Grid, { container: true, direction: "column", alignItems: "center" },
                    React.createElement(Typography, { variant: "h2" }, "Skapa ett nytt l\u00F6senord"),
                    React.createElement("br", null),
                    React.createElement(Box, { component: "div", sx: classes.container },
                        React.createElement(PasswordField, { label: "Nytt l\u00F6senord", autoComplete: "off", value: password, onChange: setPassword }),
                        React.createElement(PasswordField, { label: "Bekr\u00E4fta l\u00F6senordet", autoComplete: "off", value: confirmPassword, onChange: setConfirmPassword })),
                    (!loading && (React.createElement(ActionBar, { isSubmit: true, customText: "Uppdatera l\u00F6senordet", navigateForward: handleResetPassword, disabled: !validForm }))) || React.createElement(CircularProgress, null)))))));
};
export default ResetPassword;
